export const quickOrder = {
	quickOrderCartForm: {
		productCodePlaceholder: 'Enter Model',
		entryProductCode: 'Enter Product Model for Quick Order',
		productCodeLabel: 'Product Model',
	},
	quickOrderForm: {
		id: 'Model #{{id}}',
		idPart: 'Part #{{id}}',
		msrp: 'MSRP',
		mslp: 'MSLP',
		productNoPrice:
			"Unfortunately, it's not possible to add product to the cart at the moment. Please try again later or contact us {{phoneNumber}}. For Service Parts issues or inquiries, please call 1-800-883-7535.",
	},
	quickOrderTable: {
		id: 'Model {{id}}',
		idPart: 'Part #{{id}}',
		msrp: 'MSRP',
		mslp: 'MSLP',
	}
};